<div class="project-home">
    <h1>Project Dashboard</h1>
    <p>Welcome to your project workspace. Use the menu on the left to navigate.</p>

    <div class="dashboard-content">
        <div class="stats-grid">
            <div class="stat-card">
                <h3>Active Workflows</h3>
                <p class="stat-value">12</p>
            </div>
            <div class="stat-card">
                <h3>Total Executions</h3>
                <p class="stat-value">1,234</p>
            </div>
            <div class="stat-card">
                <h3>Success Rate</h3>
                <p class="stat-value">98.5%</p>
            </div>
            <div class="stat-card">
                <h3>Team Members</h3>
                <p class="stat-value">8</p>
            </div>
        </div>
    </div>
</div>
